import {cUtil}  from './../../../functions/util';

export class cProductItemComment {

  fieldset_comment = document.createElement('fieldset');
  label_comment    = document.createElement('label');
  textarea_comment = document.createElement('textarea');
    
  constructor(item: OrderListItem, parent: HTMLElement,) {
    const { __, _x, _n, sprintf } = wp.i18n as i18n;

    // ---- Structure ----
    parent.append(this.fieldset_comment);
      this.fieldset_comment.append(this.label_comment);
      this.fieldset_comment.append(this.textarea_comment)

    // ---- Other ----
    this.css('fieldset_comment')
    this.label_comment.textContent = __('Anmerkungen', 'custom');
    this.textarea_comment.setAttribute('maxlength', '1000');
    cUtil.labelIds(this.label_comment, this.textarea_comment);

    // ---- Init ---
    this.textarea_comment.value = item.comment;
  }

  getData() {
    return this.textarea_comment.value;
  }

  css<K extends keyof cProductItemComment>(propertyName: K): void {
    const property = this[propertyName];
    if (! (property instanceof HTMLElement)) return;
    property.classList.add(propertyName);
    property.style.gridArea = propertyName;
  }
}
